<!-- Trigger Button -->
<div class="frost-overlay-menu-container" [class.open]="isOpen">
    <!-- Custom Trigger Template or Default Button -->
    <ng-container *ngIf="customTriggerTemplate; else defaultTriggerButton">
        <ng-container *ngTemplateOutlet="customTriggerTemplate"></ng-container>
    </ng-container>

    <ng-template #defaultTriggerButton>
        <button #triggerButton type="button"
            class="frost-overlay-trigger-button {{useRoundButtons ? 'rounded-full' : 'rounded-lg'}} {{triggerButtonClass}}"
            (click)="toggle($event)" [class.active]="isOpen" [attr.aria-expanded]="isOpen" [attr.aria-haspopup]="true">
            <fa-icon [icon]="triggerIcon" [ngClass]="triggerIconColor" class="frost-overlay-trigger-icon">
            </fa-icon>
            <span class="frost-overlay-dock-indicator" [class.active]="isOpen"></span>
            <span class="frost-overlay-hover-indicator"></span>
        </button>
    </ng-template>

    <!-- Menu Overlay - SADECE menu animation ile -->
    <div class="frost-overlay-menu-wrapper" [class.dark]="darkTheme">


        <div #menuContainer *ngIf="isOpen" [@menuAnimation] class="frost-overlay-menu"
            [class.backdrop-blur-md]="backdropBlur" [class.dark]="darkTheme" [style.min-width]="minWidth"
            [style.max-height]="maxHeight" [style.--max-height]="maxHeight">

            <!-- Menu Arrow - SVG Triangle -->
            <svg *ngIf="showArrow" class="frost-overlay-menu-arrow" width="24" height="12" viewBox="0 0 24 12">
                <polygon points="12,0 24,12 0,12" [attr.fill]="darkTheme ?
                        (backdropBlur ? 'rgba(31, 41, 55, 0.85)' : 'rgba(31, 41, 55, 0.98)') :
                        (backdropBlur ? 'rgba(255, 255, 255, 0.85)' : 'rgba(255, 255, 255, 0.98)')"
                    [attr.stroke]="darkTheme ? 'rgba(55, 65, 81, 0.5)' : 'rgba(229, 231, 235, 0.5)'" stroke-width="1" />
            </svg>

            <!-- Menu Content -->
            <div class="frost-overlay-menu-content">



                <!-- Custom Header or Default Header -->
                <div class="frost-overlay-menu-header" *ngIf="menuHeaderTemplate || menuTitle">
                    <ng-container *ngIf="menuHeaderTemplate; else defaultHeader">
                        <ng-container *ngTemplateOutlet="menuHeaderTemplate"></ng-container>
                    </ng-container>

                    <ng-template #defaultHeader>
                        <div class="frost-overlay-menu-title-container">
                            <h3 class="frost-overlay-menu-title" *ngIf="menuTitle">{{menuTitle}}</h3>
                            <p class="frost-overlay-menu-description" *ngIf="menuDescription">{{menuDescription}}</p>
                        </div>
                        <div class="frost-overlay-separator" *ngIf="menuTitle || menuDescription"></div>
                    </ng-template>
                </div>

                <!-- Özel Menü İçeriği veya Standart Menü Öğeleri -->
                <ng-container *ngIf="menuContentTemplate; else standardMenuItems">
                    <div class="frost-overlay-custom-content">
                        <ng-container *ngTemplateOutlet="menuContentTemplate"></ng-container>
                    </div>
                </ng-container>

                <ng-template #standardMenuItems>
                    <!-- Menu Items -->
                    <div class="frost-overlay-menu-items" *ngIf="menuItems && menuItems.length > 0">
                        <ng-container *ngFor="let item of menuItems">
                            <!-- Separator -->
                            <ng-container *ngIf="isSeparator(item)">
                                <div class="frost-overlay-separator" 
                                    [class.empty]="!item.label && !item.description"
                                    [class.with-label]="item.label"
                                    [class.with-description]="item.description">
                                    <span *ngIf="item.label" class="frost-overlay-separator-label">{{item.label}}</span>
                                    <p *ngIf="item.description" class="frost-overlay-separator-description">{{item.description}}</p>
                                </div>
                            </ng-container>

                            <!-- Menu Item -->
                            <ng-container *ngIf="isMenuItem(item)">
                                <div class="frost-overlay-menu-item" [class.disabled]="isItemDisabled(item)"
                                    [class.with-children]="hasChildren(item)" [class.active]="isItemActive(item)"
                                    [class.with-description]="hasDescription(item)"
                                    [@hoverAnimation]="getHoverState(item)" (mouseenter)="setHoverState(item, true)"
                                    (mouseleave)="setHoverState(item, false)" (click)="onMenuItemClick(item, $event)">

                                    <!-- Özel öğe şablonu varsa onu kullan -->
                                    <ng-container *ngIf="menuItemTemplate; else defaultMenuItemTemplate">
                                        <ng-container
                                            *ngTemplateOutlet="menuItemTemplate; context: {$implicit: item}"></ng-container>
                                    </ng-container>

                                    <!-- Varsayılan menü öğesi içeriği -->
                                    <ng-template #defaultMenuItemTemplate>
                                        <!-- Icon -->
                                        <div class="frost-overlay-menu-item-icon" *ngIf="getItemIcon(item)">
                                            <fa-icon [icon]="getItemIcon(item)" [ngClass]="getItemIconColor(item)"
                                                class="frost-overlay-item-icon"></fa-icon>
                                        </div>

                                        <!-- Content -->
                                        <div class="frost-overlay-menu-item-content">
                                            <div class="frost-overlay-menu-item-label" >
                                            <span [ngClass]="getItemLabelColor(item)">   {{item.label}}</span> 
                                            </div>
                                            <div class="frost-overlay-menu-item-description"
                                                *ngIf="getItemDescription(item)">
                                                {{getItemDescription(item)}}</div>
                                        </div>

                                        <!-- Badge -->
                                        <div class="frost-overlay-menu-item-badge" *ngIf="getItemBadge(item)">
                                            <span [ngClass]="getItemBadgeColor(item)"
                                                [@pulseAnimation]="true">{{getItemBadge(item)}}</span>
                                        </div>

                                        <!-- Chevron for submenu -->
                                        <div class="frost-overlay-menu-item-chevron" *ngIf="hasChildren(item)">
                                            <fa-icon [icon]="['fal', 'chevron-right']"
                                                class="frost-overlay-item-chevron transition-transform"
                                                [class.rotate-90]="isItemActive(item)"></fa-icon>
                                        </div>
                                    </ng-template>
                                </div>

                                <!-- Submenu -->
                                <div class="frost-overlay-submenu" [@fadeInOut]
                                    *ngIf="hasChildren(item) && isItemActive(item)">

                                    <ng-container *ngFor="let subItem of getItemChildren(item)">
                                        <!-- Submenu Separator -->
                                        <ng-container *ngIf="isSeparator(subItem)">
                                            <div class="frost-overlay-separator" 
                                                [class.empty]="!subItem.label && !subItem.description"
                                                [class.with-label]="subItem.label"
                                                [class.with-description]="subItem.description">
                                                <span *ngIf="subItem.label" class="frost-overlay-separator-label">{{subItem.label}}</span>
                                                <p *ngIf="subItem.description" class="frost-overlay-separator-description">{{subItem.description}}</p>
                                            </div>
                                        </ng-container>

                                        <!-- Submenu Item -->
                                        <ng-container *ngIf="isMenuItem(subItem)">
                                            <div class="frost-overlay-menu-item frost-overlay-submenu-item"
                                                [class.disabled]="isItemDisabled(subItem)"
                                                [class.with-description]="hasDescription(subItem)"
                                                [@hoverAnimation]="getHoverState(subItem)"
                                                (mouseenter)="setHoverState(subItem, true)"
                                                (mouseleave)="setHoverState(subItem, false)"
                                                (click)="onMenuItemClick(subItem, $event)">

                                                <!-- Icon -->
                                                <div class="frost-overlay-menu-item-icon" *ngIf="getItemIcon(subItem)">
                                                    <fa-icon [icon]="getItemIcon(subItem)"
                                                        [ngClass]="getItemIconColor(subItem)"
                                                        class="frost-overlay-item-icon"></fa-icon>
                                                </div>

                                                <!-- Content -->
                                                <div class="frost-overlay-menu-item-content">
                                                    <div class="frost-overlay-menu-item-label"
                                                        [ngClass]="getItemLabelColor(subItem)">{{subItem.label}}</div>
                                                    <div class="frost-overlay-menu-item-description"
                                                        *ngIf="getItemDescription(subItem)">
                                                        {{getItemDescription(subItem)}}
                                                    </div>
                                                </div>

                                                <!-- Badge -->
                                                <div class="frost-overlay-menu-item-badge"
                                                    *ngIf="getItemBadge(subItem)">
                                                    <span [ngClass]="getItemBadgeColor(subItem)"
                                                        [@pulseAnimation]="true">{{getItemBadge(subItem)}}</span>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- Empty State -->
                    <div class="frost-overlay-empty-state" *ngIf="!menuItems || menuItems.length === 0">
                        <div class="frost-overlay-empty-icon">
                            <fa-icon [icon]="['fal', 'inbox']" class="text-gray-400"></fa-icon>
                        </div>
                        <div class="frost-overlay-empty-text">{{ emptyStateText }}</div>
                    </div>
                </ng-template>

                <!-- Custom Footer -->
                <div class="frost-overlay-menu-footer" *ngIf="menuFooterTemplate">
                    <ng-container *ngTemplateOutlet="menuFooterTemplate"></ng-container>
                </div>
            </div>


        </div>
    </div>
</div>